export default __webpack_public_path__ + "static/media/imgBoat2.70fd661b.png";